import globals from "./globals";

// Quick and dirty formatting for decimal values passed as strings.
export function formatStringInt(value) {
  return new Intl.NumberFormat("fr-FR").format(value);
}

// Quick and dirty formatting for decimal values passed as strings.
export function formatStringDecimal(value) {
  if (globals.language === "fi" || globals.language === "sv") {
    return value.replace(".", ",");
  }

  return value;
}

export function formatStringArea(area, withUnit = true) {
  const areaFloat = parseFloat(area);
  const decimals = areaFloat % 1 ? 1 : 0;
  const areaString = formatStringDecimal(areaFloat.toFixed(decimals));
  return withUnit ? `${areaString} m²` : areaString;
}

export function removeSpaces(string) {
  if (string) {
    return string.replace(/\s+/g, "");
  }
  return string;
}
